import React, { useContext, useEffect, useState } from 'react'
import Template from 'Components/Templates/Template';
import { CLIENTTAB, PROFESSIONALTAB, adminProfilePanelItems, assistantAdminProfilePanelItems, assistantProfilePanelItems, profilePanelItems, unverifiedProfilePanelItems } from 'Constants';
import { Context } from 'Context/Context';
import { useNavigate, useParams } from 'react-router-dom';
import AdminProfileRedirect from './AdminProfileRedirect';
import Header from 'Components/Header/Header';
import useIsMobile from 'Hooks/useIsMobile';
import SidePanelMobile, { SidePanelItem, MobileSectionBar } from 'Components/Professional/Cases/SidePanelMobile';
import { Menu } from 'lucide-react';

function AdminProfile() {
  const {setPanel} = useParams();
  const panel = setPanel ? setPanel : 0;
  const [activePanel, setActivePanel] = useState(panel);
  const {userDetails} = useContext(Context);
  const [openMenu, setOpenMenu] = useState(false);
    const [panelItems, setPanelItems] = useState([]);
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
 useEffect(() => {
  setPanelItems(userDetails?.isAdminAssistant ? assistantAdminProfilePanelItems : adminProfilePanelItems);
 }, [userDetails]);

    return (
      <>
        <Header />  
        {isMobile &&
          <SidePanelMobile
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            eyebrow='Account'
            title='Settings'
            content={panelItems.map((item) => (
              <SidePanelItem key={item.key} active={parseInt(activePanel) === item.key} danger={/delete/i.test(item.menu)}
                onClick={() => { setActivePanel(item.key); setOpenMenu(false); }}>
                {item.menu}
              </SidePanelItem>
            ))}
          />}
        {isMobile &&
          <MobileSectionBar
            eyebrow='Account'
            title={panelItems.find((item) => parseInt(activePanel) === item.key)?.menu || 'Profile'}
            onMenu={() => setOpenMenu(true)}
          />}
      <Template
      leaveTabs={true}
      panelItems={panelItems}
      activePanel={activePanel}
      leaveLeftPanel={isMobile ? true : false}
      setActivePanel={setActivePanel}
      content = {<AdminProfileRedirect activePanel={activePanel} setActivePanel={setActivePanel}/>}
      />
     </>
    )
}

export default AdminProfile